module.exports = __webpack_public_path__ + "static/media/Erektify uses telemedicine software for digital healthcare.00a9724a.webp";